import dan from "../../../../Images/dan.jpg";
import edward from "../../../../Images/edward.jpeg";
import elise from "../../../../Images/elise.jpg";
import stella from "../../../../Images/stella.jpg";
import david from "../../../../Images/david.jpg";
import rock from "../../../../Images/rock.jpg";
import milly from "../../../../Images/milly.jpg";
import bootstrap from "../../../../Images/bootstrap2.png";
import daniel from "../../../../Images/daniel.jpg";
import launch from "../../../../Images/launch.jpg";
import gaelle from "../../../../Images/gaelle.jpeg";
import nelly from "../../../../Images/nelly.png";
import car from "../../../../Images/car.jpg";
import rolf from "../../../../Images/rolf.jpg";
import mike from "../../../../Images/mike.jpg";
import bulma from "../../../../Images/bulma2.png";
import lana from "../../../../Images/lana.jpeg";

const feedsData = [
  {
    userName: "Dan Walker",
    userImg: dan,
    postedDate: "July 26 2018, 01:03pm",
    postCaption:
      "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock n Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
    postedImage: rock,
    likeCap: "Milly, Davidand 23 more liked this",
    likes: "25",
    shares: "9",
    comments: "3",
    img1: david,
    img2: edward,
    img3: milly,
  },
  {
    userName: "Edward Mayers",
    userImg: edward,
    postedDate: "July 26 2018, 11:14am",
    postCaption:
      "You all know how i love bootstrap, but i didn't have time to dig deeper into it. Therefore i found this very interesting video i wanted to share with you all. #bootsrap #webdesign      ",
    postedImage: bootstrap,
    likeCap: "Daniel and Elise and 11 others liked this",
    likes: "13",
    shares: "2",
    comments: "0",
    img1: daniel,
    img2: elise,
    img3: david,
  },
  {
    userName: "Elise Walker",
    userImg: elise,
    postedDate: "July 19 2018, 19:42pm",
    postCaption:
      "Thanks a lot to @Gaelle and @Rolf for this wonderful team lunch. The food was really tasty and we had some great laughs. Thanks to all the team, you're all awesome !",
    postedImage: launch,
    likeCap: "Gaelle, Edward and 5 more liked this",
    likes: "7",
    shares: "1",
    comments: "2",
    img1: gaelle,
    img2: edward,
    img3: nelly,
  },
  {
    userName: "Stella Bergmann",
    userImg: stella,
    postedDate: "July 19 2018, 15:13pm",
    postCaption:
      "Hey friends ! Iam back and i wanted to share with you some awesome pictures we took during our trip to Santa Monica. We had wonderful holidays at the beach. Kisses to all !",
    postedImage: car,
    likeCap: "Gaelle, Rolfa nd 31 more liked this",
    likes: "33",
    shares: "5",
    comments: "13",
    img1: rolf,
    img2: daniel,
    img3: mike,
  },
  {
    userName: "David Kim",
    userImg: david,
    postedDate: "August 02 2018, 03:04pm",
    postCaption:
      "Just discovered this awesome CSS framework named #bulmaCss. It's based on flexbox, so easy to use and comes with so many mobile first modifiers. You can build anything from scratch easily with Bulma. #webdesign #bulmaio",
    postedImage: bulma,
    likeCap: "Lana, Mike and 9 more liked this",
    likes: "11",
    shares: "2",
    comments: "4",
    img1: lana,
    img2: mike,
    img3: gaelle,
  },
];

export default feedsData;
